import { render, staticRenderFns } from "./IndexTable.vue?vue&type=template&id=55cd65e6"
import script from "./IndexTable.vue?vue&type=script&lang=js"
export * from "./IndexTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports